import { render, staticRenderFns } from "./ContractMinimumCharge.vue?vue&type=template&id=3a72c9bb&scoped=true&"
import script from "./ContractMinimumCharge.vue?vue&type=script&lang=js&"
export * from "./ContractMinimumCharge.vue?vue&type=script&lang=js&"
import style0 from "./ContractMinimumCharge.vue?vue&type=style&index=0&id=3a72c9bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a72c9bb",
  null
  
)

export default component.exports